import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppTranslateModule } from '@core/app-translate.module';

import { DataroomBrowserComponent } from './dataroom-browser.component';

export const imports: NgModule['imports'] = [
  MatIconModule,
  MatListModule,
  FontAwesomeModule,
  AppTranslateModule,
];

@NgModule({
  declarations: [DataroomBrowserComponent],
  imports: [...imports, CommonModule],
  exports: [DataroomBrowserComponent],
})
export class DataroomBrowserModule {}
